import { render } from "./CalendarWeekdays.vue?vue&type=template&id=2af23ea6"
import script from "./CalendarWeekdays.vue?vue&type=script&lang=js"
export * from "./CalendarWeekdays.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProSchedule/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__